import { Table, Tag } from 'antd';
import {useContext, useEffect, useState} from 'react';
import axios from "../api/axios";
import {AuthContext} from "../context/AuthContext";
import {useTranslation} from "react-i18next";

const QUERY_URL = '/api/public/query';

const columns = (t) => [
    {
        title: t("group"),
        key: 'expense_grp',
        dataIndex: 'expense_grp',
        render: (value) =>
                {
                    let color = 'gray';
                    if (value === '1')  color = 'geekblue'
                    if (value === '2')  color = 'green'
                    if (value === '4')  color = 'orange'

                    return (
                        <span>
                            <Tag color={color} key={value}>
                                    {   ( value === '0' )?'Жами':value + ' гурух' }
                            </Tag>
                        </span>
                    );

            }
    },
    {
        title: t("smeta"),
        dataIndex: 'year_smeta',
        key: 'smeta',
        align: 'right',
    },
    {
        title: t("legalObligation"),
        dataIndex: 'year_contract',
        key: 'finob',
        align: 'right',
    },
    {
        title: t("payments"),
        dataIndex: 'year_sumpay',
        key: 'paydoc',
        align: 'right',
    },
    {
        title: t("survey"),
        dataIndex: 'year_cash_app',
        key: 'cash_app',
        align: 'right',
    }

];

const dataAggregate = {
    "query": {
        "ID": "GET_AGGREGATIONS_BY_EXPGROUP_GROUPED_BY_FILIAL_FOR_EMP_ID",
        "source": "GET_AGGREGATIONS_BY_EXPGROUP_GROUPED_BY_FILIAL_FOR_EMP_ID",
        "fields": [
            {   "column": "filial"},
            {   "column": "expense_grp"},
            {   "column": "year_smeta", "format": "sum", "type": "char"},
            {   "column": "year_sumpay","format": "sum", "type": "char"},
            {   "column": "year_contract","format": "sum", "type": "char"},
            {   "column": "year_cash_app","format": "sum", "type": "char"},
            {   "column": "ordnumb"},
        ]
    }
}

const HomeTable = () => {

    const auth = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [aggregateData, setAggregateData] = useState([]);

    const { t } = useTranslation("dashboard");

    const headers = {'Content-Type':'application/json;charset=utf-8',
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Credentials':'true',
        'Authorization':`Bearer ${auth.token}`,
        'withCredentials': true
    }

    const getAggregateData = async (filter = '') => {
        dataAggregate.query.source = "GET_AGGREGATIONS_BY_EXPGROUP_GROUPED_BY_FILIAL_FOR_EMP_ID("+auth.empId+")"
        const { data } = await axios.post(QUERY_URL,
            ( dataAggregate ),
            {
                headers: headers,
                //crossDomain: true,
                withCredentials: false
            });
        setLoading(false);
        setAggregateData(data);
    };

    useEffect(()=>{
        getAggregateData()
    },[])

    return (
        <div>
            <Table
                rowKey="expense_grp"
                key="expense_grp"
                columns={columns(t)}
                dataSource={aggregateData}
                pagination={false}
            />
        </div>
    );
};
export default HomeTable;